import React, {useCallback, useEffect, useState} from 'react';
import {Input, Popup} from "semantic-ui-react";
import debounce from "lodash.debounce";
import DualRangeSlider from "../../components/DualRangeSlider";
import SvgNew from "../../components/SvgNew";
import ClearableInput from "../../components/Input/ClearableInput";
import {getSelectOptions} from "../api";
import {isNumber} from "../../services/utils";
import {settingsWithoutThis} from "../utils";

const NumberFilter = ({filter, column, setFilter, unit, filterParams}) => {

    const isValidNumber = (v) => isNumber(v) && !Number.isNaN(v);

    const changeFilter = (v) => {
        const hasValue = Array.isArray(v) && (isValidNumber(v[0]) || isValidNumber(v[1]));

        setFilter({
            fieldName: column.fieldName,
            operation: 'between',
            value: hasValue ? v.toString() : null
        })
    }

    const style = {
        border: '1px solid #135CA9',
        padding: '12px',
        borderRadius: '4px'
    }

    const getValue = (i) => {
        const value = ((filter || {}).value || '').split(',')[i];
        const numberValue = value !== undefined && value !== '' ? Number(value) : null;
        return isValidNumber(numberValue) ? numberValue : null;
    }

    const [v1, setV1] = useState(getValue(0));
    const [v2, setV2] = useState(getValue(1));

    const [min, setMin] = useState(null);
    const [max, setMax] = useState(null);

    useEffect(() => {
        setV1(getValue(0));
        setV2(getValue(1));
    }, [(filter || {}).value]);

    useEffect(() => {
        if (!isValidNumber(min) && !isValidNumber(max)) {
            return;
        }

        if (isValidNumber(v1)) {
            if (isValidNumber(max) && v1 > max) setV1(max);
            if (isValidNumber(min) && v1 < min) setV1(min);
        }

        if (isValidNumber(v2)) {
            if (isValidNumber(max) && v2 > max) setV2(max);
            if (isValidNumber(min) && v2 < min) setV2(min);
        }
    }, [min, max]);

    const setValues = (v1, v2) => {
        changeFilter([v1, v2]);
    }

    const getSelectOpts = (column, filterParams) => {
        getSelectOptions(column.fieldName, filterParams).then(v => {
            setMin(Math.floor(v.minValue))
            setMax(Math.ceil(v.maxValue))
        })
    }

    const getSelectOptionsDebounce = useCallback(debounce(getSelectOpts, 2000), []);

    useEffect(() => {
        getSelectOptionsDebounce(column, settingsWithoutThis(filterParams, column.fieldName))
    }, [column, filterParams]);

    // useEffect(() => {
    //     (v1 || v2) && setFilterValues(v1, v2)
    // }, [v1, v2])
    //
    // const setFilterValues = useCallback(debounce(setValues, 1000), []);

    return (
        <Popup
            onClose={() => setValues(v1, v2)}
            style={style}
            on='click'
            basic
            position='bottom left'
            pinned
            trigger={
                <ClearableInput
                    readOnly
                    withSort={true}
                    sizer={true}
                    compact
                    onChange={(e, {value}) => {
                        setV1(null);
                        setV2(null);
                        changeFilter(value)
                    }}
                    value={(isValidNumber(v1) || isValidNumber(v2)) ? `${isValidNumber(v1) ? v1 : (isValidNumber(min) ? min : '')} — ${isValidNumber(v2) ? v2 : (isValidNumber(max) ? max : '')}${unit ? `, ${unit}` : ''}` : ''}
                    placeholder={column.title}
                />
            }
        >
            <div className='filter-inputs'>
                <Input
                    type='number'
                    value={isValidNumber(v1) ? v1 : ''}
                    min={min}
                    max={v2}
                    onChange={(e, {value}) => setV1(Math.min(value, max || value))}
                />
                <SvgNew name='dash'/>
                <Input
                    type='number'
                    value={isValidNumber(v2) ? v2 : ''}
                    min={v1}
                    max={max}
                    onChange={(e, {value}) => setV2(Math.min(value, max || value))}
                />
            </div>
            {(min || max) ? <DualRangeSlider
                v1={v1}
                v2={v2}
                max={max}
                min={min}
                onChange={({min, max}) => {
                    setV1(min);
                    setV2(max);
                }}
            /> : null}
        </Popup>
    );
};

export default NumberFilter;


// WEBPACK FOOTER //
// ./App/grids/filters/number.jsx